<template>
  <div class="content body">
    <div class="tools-box" style="margin: 20px 30px 0 30px">
      <h1>
        {{ productName }} <span style="font-size: 0.8em; margin-left: 20px">编码：{{ code }}</span>
      </h1>
      <Button type="primary" ghost @click="backPage">返回</Button>
    </div>

    <Tabs v-model="rankLevel" :animated="false" style="padding-top: 10px" @on-click="val => getDataList()">
      <TabPane v-for="bean in tabList" :key="bean.value" :label="bean.label" :name="bean.value">
        <div class="body" :loading="loading">
          <div class="tableBox">
            <loading :isShow="loading" />
            <Table ref="currCommissionTableRef" :columns="currCommissionColumns" :data="tableData" > </Table>
          </div>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  name: 'productMerchant',
  computed: {
    isIFA() {
      return this.userInfo.isIFA;
    }
  },
  data: () => ({
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    productName: '',
    productId: '',
    code: '',
    loading: false,
    tableData: [],
    tableSpanObj: {},
    currCommissionColumns: [],
    currCommissionDataList: [],
    maxReturnYear: '',
    pageParams: {
      pageNum: 1,
      pageSize: 10,
      total: 0
    },
    tabList: [
      {
        label: '王者',
        value: '4'
      },
      {
        label: '精英',
        value: '3'
      },
      {
        label: '萌新/新贵',
        value: '1'
      }
    ],
    indexArr: [
      'firstCommission',
      'secondCommission',
      'thirdCommission',
      'fourthCommission',
      'fifthCommission',
      'sixthCommission',
      'seventhCommission',
      'eighthCommission',
      'ninthCommission',
      'tenthCommission'
    ],

    rankLevel: '4'
  }),
  async activated() {
    this.productName = this.$route.query.name;
    this.productId = this.$route.query.id;
    this.code = this.$route.query.code;
    this.getDataList();
  },
  methods: {
    setCurrCommissionColumns() {
      let indexArr = this.indexArr;
      let columns = [];
      if (this.isIFA && (this.tableData.filter(i => i.isInvestor).length || this.tableData.length == 0)) {
        columns.push({
          title: '专业/非专业投资者',
          key: 'isInvestor',
          align: 'center',
          minWidth: 100,
          fixed: 'left',
          render(h, params) {
            if (params.row.isInvestor === '1') {
              return <div>专业投资者</div>;
            } else if (params.row.isInvestor === '0') {
              return <div>非专业投资者</div>;
            } else {
              return <div>-</div>;
            }
          }
        });
      }

      if (this.tableData.filter(i => i.feeRange).length || this.tableData.length == 0) {
        columns.push({
          title: '保费区间',
          key: 'feeRange',
          align: 'center',
          minWidth: 160,
          fixed: 'left',
          render(h, params) {
            return <div>{params.row.feeRange || '-'}</div>;
          }
        });
      }

      if (this.tableData.filter(i => i.age).length || this.tableData.length == 0) {
        columns.push({
          title: '年龄影响因子',
          key: 'age',
          align: 'center',
          minWidth: 140,
          fixed: 'left',
          render(h, params) {
            return <div>{params.row.age || '-'}</div>;
          }
        });
      }

      if (this.tableData.filter(i => i.paymentPeriod).length || this.tableData.length == 0) {
        columns.push({
          title: '缴费年限',
          align: 'center',
          fixed: 'left',
          key: 'paymentPeriod',
          width: 100
        });
      }
      for (let i = 0; i < this.maxReturnYear; i++) {
        columns.push({
          title: i === 0 ? '首年' : `第${i + 1}年（%）`,
          key: indexArr[i],
          align: 'center',
          minWidth: 100,
          render(h, params) {
            return <div>{params.row[indexArr[i]] || '-'}</div>;
          }
        });
      }
      this.currCommissionColumns = columns;
    },
    getDataList() {
      this.loading = true;
      this.$http({
        url: '/buz/productCommissionConfig/queryDetail',
        type: 'POST',
        data: {
          productId: this.productId,
          isCurrent: 1,
          rankLevel: this.rankLevel
        }
      })
        .then(res => {
          this.maxReturnYear = res.data.maxReturnYear || 10;
          this.loading = false;
          window.scrollTo(0, 0);
          this.tableSpanObj = {};
          this.tableData = res.data.configList.map(item => {
            item.rateRule = JSON.parse(item.rateRule);
            this.indexArr.forEach((key, idx) => {
              item[key] = item.rateRule[idx];
            });
            return item;
          });

          this.setCurrCommissionColumns();
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    backPage() {
      this.back('/operate/productManage/index');
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../product';
/deep/.ivu-tabs-nav {
  padding-left: 25px;
}
</style>
